site.window = {
	scrollPosition: 0
};

site.nav = {
	// Init navigation scripts
	init: function () {
		// Add expand link to mobile menu
		$('.children', '#sidebarmenu ').prepend('<span class="expand" href="#"><i class="fa fa-angle-down"</span>');
		$('.selectedLevel1', '#sidebarmenu').addClass('down');
		$('.selectedLevel2', '#sidebarmenu').addClass('down');
		site.nav.bind();
		site.nav.appendLanguage();
	},
	bind: function () {
		// Mobile menu toggle
		$('#mainmenuToggle').click(function (e) {
			$('body').removeClass('dropdown-open');
			$('body').toggleClass('mainmenu-open');
			$('body.mainmenu-open').on('click', function (e) {
				$('body').removeClass('mainmenu-open');
			});
			e.stopPropagation();
			e.preventDefault();
		});

		// Close sidebar on esc press
		$(document).keydown(function (e) {
			if (e.keyCode == 27) {
				$('body').removeClass('mainmenu-open');
				$('body').removeClass('dropdown-open');
			}
		});

		$('#sidebarmenu').on('click', function (e) {
			e.stopPropagation();
		});

		$('a.moreUrl', '#sidebarmenu').on('click', function (e) {
			var href = $(this).attr('href');
			console.log(this.hash);

			if (this.pathname === window.location.pathname &&
				this.protocol === window.location.protocol &&
				this.host === window.location.host &&
				this.hash !== '') {
				$('body').removeClass('mainmenu-open');
				e.preventDefault();
				window.location.hash = this.hash.substring(1);
				var hashElement = $(this.hash);
				if (hashElement.length > 0) {
					$('html, body').animate({scrollTop: hashElement.offset().top}, 'slow');
				}
			}
		});

		// Expand in mobile menu
		$('.expand', '#sidebarmenu').bind('click', function (e) {
			e.preventDefault();
			$(this).closest('li').toggleClass('down');
		});
	},

	appendLanguage: function () {
		var $divisions = $('.qn ul a', '#header');
		var $menu = $('ul.mmLevel1', '#mainmenu');

		$divisions.each(function () {
			$this = $(this);
			$item = $(this).clone().text($this.attr('title'));
			$menu.append('<li class="level1 el-language">' + $item.prop('outerHTML') + '</li>');
		});
	}
};

site.inits.push('site.nav.init()');
